import EventEmitter from 'eventemitter3';
import styles from './styles.module.scss';

type DataItem = {
  key: string;
  value: string;
};

type Token = {
  '--theme-container-background-color': string;
  '--theme-color': string;
  '--theme-color-hover': string;
  '--theme-background-color-selected': string;
  '--theme-color-selected': string;
  '--theme-background-color': string;
};

type Option = {
  data?: DataItem[];
  buttonArray?: string[];
  token?: Token;
};

type EventTypes = {
  change: (dataItem: DataItem) => void;
};

function handleClick(targetButton: HTMLElement, buttons: NodeListOf<Element>) {
  // 清除所有按钮的"selected" 类
  buttons.forEach(btn => btn.classList.remove(styles.selected));

  // 将点击的按钮添加 "selected" 类
  targetButton.classList.add(styles.selected);
}

export default class ButtonGroup extends EventEmitter<EventTypes> {
  private __$dom!: HTMLElement;

  private __option: Option;

  private __buttonNameArray!: string[];

  private __data!: Option['data'];

  constructor($container: HTMLElement, option: Option) {
    super();

    this.__option = option;
    this.__data = option.data || [];
    this.__$dom = $container;
    this.__buttonNameArray = option?.buttonArray || [];

    this.__initialize();

    this.__bindEvents();
  }

  /** 初始化主题 */
  private __initTheme($dom: HTMLElement) {
    const themeConfig = this.__option.token;
    if (!themeConfig) {
      return;
    }

    Object.keys(themeConfig).forEach(key => {
      $dom.style.setProperty(key, themeConfig[key]);
    });
  }

  private __initialize() {
    const $buttonContainer = document.createElement('div');
    $buttonContainer.classList.add(
      'js-buttonGroup-buttonContainer',
      styles['button-container'],
      styles['theme-container']
    );

    const buttonNameArray = this.__buttonNameArray;
    // 生成对应数量的按钮，并默认选择第一个按钮
    buttonNameArray.forEach((name, index) => {
      const $button = document.createElement('div');
      $button.classList.add('js-buttonGroup-button', styles.button);
      $button.textContent = name;
      $buttonContainer.appendChild($button);
      if (!index) {
        $button.classList.add(styles.selected);
      }
    });

    this.__$dom.appendChild($buttonContainer);
    this.__initTheme($buttonContainer);
  }

  init() {
    const buttons = this.__$dom.querySelectorAll('.js-buttonGroup-button') || [];
    buttons.forEach((button: HTMLElement, index) => {
      button.classList.remove(styles.selected);

      if (!index) {
        button.classList.add(styles.selected);
      }
    });
  }

  private __bindEvents() {
    const self = this;

    const buttons = self.__$dom.querySelectorAll('.js-buttonGroup-button') || [];
    buttons.forEach((button: HTMLElement, index) => {
      button.addEventListener('click', () => {
        handleClick(button, buttons);
        const data = this.__data;
        this.emit('change', data[index]);
      });
    });
  }

  destroy() {
    const self = this;

    const buttons = self.__$dom.querySelectorAll('.js-buttonGroup-button') || [];
    buttons.forEach((button: HTMLElement) => {
      button.removeEventListener('click', handleClick);
    });
    self.__$dom.classList.remove(styles.outer);
  }
}
